var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31356 2.5V5.04237M12.6695 2.5V5.04237M8.11556 16.483H5.04237C3.63828 16.483 2.5 15.3448 2.5 13.9407V6.31356C2.5 4.90937 3.63828 3.77119 5.04237 3.77119H13.9407C15.3448 3.77119 16.483 4.90937 16.483 6.31356V7.58475H2.5",
    stroke: "#807A98",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6864 17.5C15.7926 17.5 17.5 15.7926 17.5 13.6864C17.5 11.5803 15.7926 9.87286 13.6864 9.87286C11.5803 9.87286 9.87288 11.5803 9.87288 13.6864C9.87288 15.7926 11.5803 17.5 13.6864 17.5Z",
    stroke: "#807A98",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6855 12.4153V13.6865H14.9567",
    stroke: "#807A98",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.8460e4b618355a8fedbab06953050dea.svg";
export { ForwardRef as ReactComponent };